<template lang="pug">
modal#envelope-sent-modal(
  :showCancelButton='false'
  :title='$t("modal.envelopeSubmittedToReview.title")'
  @closed='redirectDocuments'
  @process='closeModal'
  process-button-label='Ok'
  ref='modal'
  size='sm'
)
  .text {{ $t('modal.envelopeSubmittedToReview.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/no-drafts-found.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'EnvelopeSubmittedToReviewModal',
  components: {
    Modal,
  },
  methods: {
    redirectDocuments() {
      this.$router.push('/business/documents/waiting-review');
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
